import { type ComponentProps, memo, type ReactNode } from 'react';

import { tailwindVariants } from '@air/utils-tailwind';

export const breadcrumbsButton = tailwindVariants({
  base: 'flex min-w-0 items-center rounded-4 font-medium ads:text-secondary text-gray-11 outline-none hover:ads:bg-hover-subtle hover:bg-gray-3 hover:ads:text-secondary hover:text-gray-11 focus-visible:ads:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9 active:ads:bg-hover-subtle active:bg-gray-4 active:ads:text-primary active:text-gray-12',
  defaultVariants: {
    size: 'small',
  },
  variants: {
    size: {
      large: 'h-10 gap-2 px-4',
      medium: 'h-8 gap-2 px-3',
      small: 'h-6 gap-1 px-1',
    },
  },
});

export type BreadcrumbsButtonProps = Omit<ComponentProps<'button'>, 'prefix'> & {
  onClick: () => void;
  prefix?: ReactNode;
  suffix?: ReactNode;
};

export const BreadcrumbsButton = memo(
  ({ children, className, prefix, suffix, ...restOfProps }: BreadcrumbsButtonProps) => {
    return (
      <button className={breadcrumbsButton({ class: className })} data-testid="BREADCRUMBS_BUTTON" {...restOfProps}>
        {!!prefix && <div className="shrink-0">{prefix}</div>}

        <div className="min-w-0 flex-1 truncate">{children}</div>

        {!!suffix && <div className="shrink-0">{suffix}</div>}
      </button>
    );
  },
);

BreadcrumbsButton.displayName = 'BreadcrumbsButton';
